export const JENIS_MUATAN_PER_PRIORITAS_URL = 'dashboard/jenis_muatan_per_prioritas'
export const JENIS_MUATAN_PER_PRIORITAS_ERROR = 'JENIS_MUATAN_PER_PRIORITAS_ERROR'
export const JENIS_MUATAN_PER_PRIORITAS_LOADING = 'JENIS_MUATAN_PER_PRIORITAS_LOADING'
export const JENIS_MUATAN_PER_PRIORITAS_SUCCESS = 'JENIS_MUATAN_PER_PRIORITAS_SUCCESS'